/**
 * IconSignal Component
 *
 * Custom SVG icon for Signal messenger.
 * Matches Phosphor icon API (size, color props).
 *
 * Based on official Signal brand assets.
 */
export const IconSignal = ({ size = 24, color = 'currentColor', weight = 'regular', ...props }) => {
  // Signal logo - speech bubble with signal waves
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      {/* Signal logo path - simplified speech bubble with dot */}
      <path
        d="M12 2C6.477 2 2 6.145 2 11.259c0 2.913 1.454 5.512 3.726 7.21V22l3.405-1.869c.898.249 1.857.385 2.869.385 5.523 0 10-4.145 10-9.257C22 6.145 17.523 2 12 2z"
        stroke={color}
        strokeWidth={weight === 'bold' ? 2 : 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Inner dot */}
      <circle cx="12" cy="11" r="2" fill={color} />
    </svg>
  );
};

export default IconSignal;
